// extracted by mini-css-extract-plugin
export default {"agentReviewsEmptyList":"agentReviewsEmptyList_nEpOv","title":"title_PPOuS","description":"description_xSQY9","buttonContainer":"buttonContainer_knPQm"};